import { useEffect } from 'react';
import { his } from '../../../../../pages/history';
import { Modal } from 'antd';
import { track } from '../../../../../tracking';

const BlockHistory: React.FC<{ onSave: () => Promise<void> }> = ({ onSave }) => {
    useEffect(() => {
        const unblock = his.block((tx) => {
            const t = Modal.confirm({
                title: (
                    <span className="flex mr-24 text-center">
                        Your changes are not saved. Do you want to save?
                    </span>
                ),
                content: (
                    <span className="flex text-14 mr-24 text-darwin-neutral-800 text-left">
                        All your current changes will be lost and cannot be recovered later.
                    </span>
                ),
                okText: 'Save',
                cancelText: "Don't Save",
                okButtonProps: { className: 'primary-btn font-lato rounded-4' },
                cancelButtonProps: { className: 'neutral-btn font-lato rounded-4' },
                visible: true,
                className: 'rounded-8 w-400',
                width: 470,
                keyboard: true,
                closable: true,
                onOk: async () => {
                    t.update({
                        okButtonProps: {
                            loading: true,
                            className: 'primary-btn font-lato cursor-pointer',
                        },
                    });

                    setTimeout(() => {
                        const el: HTMLDivElement = document.getElementsByClassName(
                            'ant-modal-wrap',
                        )[0] as HTMLDivElement;
                        el?.focus();
                    }, 200);

                    await onSave();

                    unblock();

                    his.push({
                        pathname: tx.pathname,
                        state: tx.state,
                    });
                },
                onCancel: (args) => {
                    if (args?.triggerCancel) {
                        return;
                    }

                    unblock();

                    his.push({
                        pathname: tx.pathname,
                        state: tx.state,
                    });
                    track("CARE_CANVAS_DON'T_SAVE");
                    t.destroy();
                    return;
                },
                bodyStyle: { padding: '24px' },
            });

            t.update({
                okButtonProps: { className: 'primary-btn font-lato cursor-pointer rounded-4' },
                cancelButtonProps: {
                    className: 'neutral-btn font-lato cursor-pointer rounded-4',
                },
            });

            setTimeout(() => {
                const el: HTMLDivElement = document.getElementsByClassName(
                    'ant-modal-wrap',
                )[0] as HTMLDivElement;
                el?.focus();
            }, 200);

            return false;
        });

        return () => {
            unblock();
        };
    }, []);

    return null;
};

export default BlockHistory;
